var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShowMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.108 13.386H0v7.454l2.206-2.031a11.913 11.913 0 0 0 9.716 5.016c6.085 0 11.1-4.558 11.836-10.439h-3.013a8.946 8.946 0 0 1-8.823 7.454 8.927 8.927 0 0 1-7.497-4.068l3.684-3.386h-5zM11.922-.028C5.845-.028.822 4.521.095 10.411h3.013a8.935 8.935 0 0 1 8.814-7.454 8.93 8.93 0 0 1 7.643 4.286L16.4 10.411h7.454V2.957L21.719 5.09a11.92 11.92 0 0 0-9.797-5.117z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowMore);
export default __webpack_public_path__ + "static/media/show-more.1cee222206fe6284997fc04f71b40991.svg";
export { ForwardRef as ReactComponent };